var exports = {
  "V": "Background__vHEnmV",
  "b": "Visual__gm-ITp",
};

module.exports = exports;
